import { useSelector } from "react-redux";
import React, { memo, useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import AutoSizer from "react-virtualized-auto-sizer";
import parse from "html-react-parser";
import ShowMoreText from "react-show-more-text";

import { useTranslation } from 'react-i18next';
import { formatNumber_N1, formatNumberToB_N1 } from '../../helpers/utils';

import { getProfile } from '../../helpers/apiTTDNHelper'

export default memo(function HoSo(props) {
    const { t } = useTranslation();
    const language = useSelector(state => state.gShared.language);
    const { code } = props;
    const [datas, setDatas] = useState(null);
    const [enCompanyProfile, setEnCompanyProfile] = useState('');
    const [companyProfile, setCompanyProfile] = useState('');

    useEffect(() => {
        getProfile(code).then((res) => {
            setDatas(res.data);
            setCompanyProfile(res.data.objOrganization?.companyprofile || "");
            setEnCompanyProfile(res.data.objOrganization?.en_Companyprofile || "");
            // setCompanyProfile(parse(res.data.objOrganization?.companyprofile || "",options)??"");
            // setEnCompanyProfile(parse(res.data.objOrganization?.en_Companyprofile || "",options)??"");
        });
    }, [code]);

    const htmlDecode = (input) => {
        var e = document.createElement('textarea');
        e.innerHTML = input;
        return e.value; //.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }

    const companyContent = () => {
        return language === 'en' && enCompanyProfile !== null ? parse(htmlDecode(enCompanyProfile)) : companyProfile !== null ? parse(htmlDecode(companyProfile)) : null;
    }

    return (
        <div className='d-flex h-100'>
            <div className='d-flex flex-column bl-profile' style={{ width: '65%' }}>

                <AutoSizer>
                    {({ height, width }) => {
                        return (
                            <div style={{ height: height, width: width }}>
                                <div className="scroll-styled" >
                                    <div className="pd-intro">
                                        <div className="title-profile">{t("gioiThieu").toUpperCase()}</div>
                                        <div id="txt-intro" className="txt-intro" style={{ display: "inherit" }}>
                                            {language === 'en' ?
                                                (<ShowMoreText
                                                    lines={5}
                                                    more="Read more"
                                                    less="Less more"
                                                    anchorClass="text-more-less"
                                                    expanded={false}
                                                    width={0}
                                                >
                                                    {companyContent()}
                                                </ShowMoreText>) :
                                                (<ShowMoreText
                                                    lines={5}
                                                    more={t("docThem")}
                                                    less={t("rutGon")}
                                                    anchorClass="text-more-less"
                                                    expanded={false}
                                                    width={0}
                                                >
                                                    {companyContent()}
                                                </ShowMoreText>)}
                                        </div>

                                        <div className='tab-profile'>
                                            <Tabs className='h-100'>
                                                <TabList>
                                                    {/* <Tab>{t("congTyCon")}</Tab> */}
                                                    <Tab>{t("banLanhDao")}</Tab>
                                                    <Tab className='tab-profile-mb'>{t("thongTinCoBan")}</Tab>

                                                </TabList>
                                                {/* <TabPanel>
                                                    <table className="tbl-companychild">
                                                        <thead>
                                                            <tr>
                                                                <th className='pl-0'>{t("congTyCon").toUpperCase()}</th>
                                                                <th className='pl-0'>{t("ma").toUpperCase()}</th>
                                                                <th className='text-right'>{t("vonDieuLe").toUpperCase()}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                datas && datas.lstOrganization && 
                                                                    datas.lstOrganization.map(
                                                                        (data,index)=>(
                                                                            <tr>
                                                                                <td className='pl-0'>{data.organname}</td>
                                                                                <th className='pl-0'>{data.ticker}</th>
                                                                                <td className='text-right'>{formatNumberToB_N1(data.chartercapital)} {t('ty')}</td>
                                                                            </tr>
                                                                    )
                                                                ) 
                                                            }
                                                        </tbody>
                                                    </table>
                                                </TabPanel> */}
                                                <TabPanel>
                                                    <table className="tbl-leadership">
                                                        <thead>
                                                            <tr>
                                                                <th className='pl-0'>{t("ten").toUpperCase()}</th>
                                                                <th className='text-right pr-0'>{t("chucVu").toUpperCase()}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                datas && datas.lstBoardOfDirector &&
                                                                datas.lstBoardOfDirector.map(
                                                                    (data, index) => (
                                                                        <tr key={index}>
                                                                            <td className='name-leadership'>{language === 'en' ? data.en_Fullname : data.fullname}</td>
                                                                            <td className='text-right'>{language === 'en' ? data.en_Positionname : data.positionname}</td>
                                                                        </tr>
                                                                    )
                                                                )
                                                            }

                                                            {/* <tr>
                                                                <td className='name-leadership'>Phạm Ánh Dương</td>
                                                                <td className='text-right'>Chủ tịch Hội đồng Quản trị</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='name-leadership'>Phạm Ánh Dương</td>
                                                                <td className='text-right'>Chủ tịch Hội đồng Quản trị</td>
                                                            </tr>
                                                            <tr>
                                                                <td className='name-leadership'>Phạm Ánh Dương</td>
                                                                <td className='text-right'>Chủ tịch Hội đồng Quản trị</td>
                                                            </tr> */}
                                                        </tbody>
                                                    </table>
                                                </TabPanel>
                                                <TabPanel className="tab-profile-mb mt-3" style={{ padding: "0", border: "0", display: "block" }}>
                                                    <div className='boxinfo--right'>
                                                        {/* <div className="txt-leadership">{t("thongTinCoBan").toUpperCase()}</div> */}
                                                        <div className="list-leadership">
                                                            <table className="tb-leadership">
                                                                <tr>
                                                                    <td className='clr-gr'>{t("maSIC")}</td>
                                                                    <td className='text-right'>{datas && datas.objOrganization.ticker}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className='clr-gr'>{t("maNganhICB")}</td>
                                                                    <td className='text-right'>{datas && datas.objOrganization.icbcode}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("namThanhLap")}</td>
                                                                    <td className='text-right'>{datas && (new Date(datas.objOrganization.foundingdate)).toLocaleDateString('en-GB')}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("vonDieuLe")}</td>
                                                                    <td className='text-right'>{datas && formatNumberToB_N1(datas.objOrganization.chartercapital)} {t('ty')}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("soLuongNhanSu")}</td>
                                                                    <td className='text-right'>{datas && formatNumber_N1(datas.objOrganization.numberofemployee)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("ngayNiemYet")}</td>
                                                                    <td className='text-right'>{datas && (new Date(datas.objOrganization.listingdate)).toLocaleDateString('en-GB')}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("noiNiemYet")}</td>
                                                                    <td className='text-right'>{datas && datas.objOrganization.comgroupcode}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("giaChaoSan")} (VNĐ)</td>
                                                                    <td className='text-right'>{datas && formatNumber_N1(datas.objOrganization.firstprice)}</td>
                                                                </tr>
                                                                {/* <tr>
                            <td className='clr-gr'>{t("ngayPhatHanhCuoi")}</td>
                            <td className='text-right'>N/A</td>
                        </tr> */}
                                                                <tr>
                                                                    <td className='clr-gr'>{t("klDangNiemYet")}</td>
                                                                    <td className='text-right'>{datas && formatNumber_N1(datas.objOrganization.issueshare)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='clr-gr'>{t("nganh")}</td>
                                                                    <td className='text-right'>
                                                                        {datas ? (language === 'en' ? datas.objOrganization.descript_en : datas.objOrganization.descript) : ''}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            </Tabs>
                                        </div>



                                    </div>

                                </div>
                            </div>
                        )
                    }}
                </AutoSizer>
            </div>

            <div className='boxinfo--right'>
                <div className="txt-leadership">{t("thongTinCoBan").toUpperCase()}</div>
                <div className="list-leadership">
                    <table className="tb-leadership">
                        <tr>
                            <td className='clr-gr'>{t("maSIC")}</td>
                            <td className='text-right'>{datas && datas.objOrganization.ticker}</td>
                        </tr>

                        <tr>
                            <td className='clr-gr'>{t("maNganhICB")}</td>
                            <td className='text-right'>{datas && datas.objOrganization.icbcode}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("namThanhLap")}</td>
                            <td className='text-right'>{datas && (new Date(datas.objOrganization.foundingdate)).toLocaleDateString('en-GB')}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("vonDieuLe")}</td>
                            <td className='text-right'>{datas && formatNumberToB_N1(datas.objOrganization.chartercapital)} {t('ty')}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("soLuongNhanSu")}</td>
                            <td className='text-right'>{datas && formatNumber_N1(datas.objOrganization.numberofemployee)}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("ngayNiemYet")}</td>
                            <td className='text-right'>{datas && (new Date(datas.objOrganization.listingdate)).toLocaleDateString('en-GB')}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("noiNiemYet")}</td>
                            <td className='text-right'>{datas && datas.objOrganization.comgroupcode}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("giaChaoSan")} (VNĐ)</td>
                            <td className='text-right'>{datas && formatNumber_N1(datas.objOrganization.firstprice)}</td>
                        </tr>
                        {/* <tr>
                            <td className='clr-gr'>{t("ngayPhatHanhCuoi")}</td>
                            <td className='text-right'>N/A</td>
                        </tr> */}
                        <tr>
                            <td className='clr-gr'>{t("klDangNiemYet")}</td>
                            <td className='text-right'>{datas && formatNumber_N1(datas.objOrganization.issueshare)}</td>
                        </tr>
                        <tr>
                            <td className='clr-gr'>{t("nganh")}</td>
                            <td className='text-right'>
                                {datas ? (language === 'en' ? datas.objOrganization.descript_en : datas.objOrganization.descript) : ''}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
    )
})